import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-3" }
const _hoisted_2 = { class: "flex flex-ai-c flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuccessFilled = _resolveComponent("SuccessFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_icon, { class: "fc-blue fs-60" }, {
        default: _withCtx(() => [
          _createVNode(_component_SuccessFilled)
        ]),
        _: 1
      }),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "fs-24 bold mg-t-20 fc-black" }, "导入成功", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "fs-14 fc-lightgray mg-t-10" }, "成功后可在列表中查看员工应发薪资，导出薪资表，可去批量发薪", -1))
    ])
  ]))
}